var angular = require('angular');
var _module = angular.module('benoit');

require('../../countdown-timer');

_module.controller('ViewPrivateListingHeaderCtrl', [
    '$log',

    function ViewPrivateListingHeaderCtrl($log) {
        $log.debug('ViewPrivateListingHeaderCtrl', this);
    }
]);

_module.component('viewPrivateListingHeader', {
    controllerAs: 'vm',
    controller: 'ViewPrivateListingHeaderCtrl',
    template: require('./index.html'),
    bindings: {
        abnListing: '<'
    }
});
